import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { GoodPlaceMatch } from './GoodPlaceMatch';

function App() {
  return (
    <AuthProvider>
      <GoodPlaceMatch standalone={true} />
    </AuthProvider>
  );
}

export default App;
